import { observer } from 'mobx-react';
import { UserProductLicenseResource } from '../../../../../../ParticipantsStore/Types';
import { T } from '../../../../../../Translations';
import MultiValueCell from '../../MultiValueCell';

interface Props {
  licenses: ReadonlyArray<UserProductLicenseResource>;
}

/** A person can hold several terms of one product; show each product once. */
const productNames = (licenses: ReadonlyArray<UserProductLicenseResource>): string[] =>
  Array.from(new Set(licenses.map((license) => license.payload.name)));

function LicenseCell({ licenses }: Props) {
  return (
    <MultiValueCell
      values={productNames(licenses)}
      none={
        <span style={{ fontSize: 'var(--text-sm)', color: 'var(--destructive)' }}>
          <T kind="None" />
        </span>
      }
    />
  );
}

export default observer(LicenseCell);
